import React from 'react';

export default function useStableCallback(callback) {
  const callbackRef = React.useRef(callback);
  callbackRef.current = callback;
  return React.useCallback((...args) => callbackRef.current?.(...args), []);
}
